exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-36c16216] {\n  min-width: 300px;\n  background-color: #f8f8f8 !important;\n}\n.card.shadow[data-v-36c16216] {\n  box-shadow: 0 0.5rem 0.5rem rgba(0, 0, 0, 0.2) !important;\n}\n.card .card-header[data-v-36c16216] {\n  background-color: #eee;\n  font-weight: 700;\n  border: 0;\n}", ""]);

// exports
